module.exports = __webpack_public_path__ + "img/amsFA5.59937da0.png";